var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4271 25.6667V16.76H21.4253L21.8739 13.2893H18.426V11.0732C18.426 10.0681 18.7062 9.38275 20.1522 9.38275H21.995V6.27775C21.1026 6.18304 20.2056 6.13697 19.3081 6.13975C16.6513 6.13975 14.8327 7.7578 14.8327 10.7282V13.2893H11.8253V16.76H14.8316V25.6667H3.87318C3.16976 25.6667 2.6001 25.0986 2.6001 24.3971V3.93635C2.6001 3.23485 3.16976 2.66675 3.87318 2.66675H24.3901C25.0935 2.66675 25.6632 3.23485 25.6632 3.93635V24.3971C25.6632 25.0986 25.0935 25.6667 24.3901 25.6667H18.4271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b965e17744bc455e07868aac36234c05.svg";
export { ForwardRef as ReactComponent };